import { BottomSheet, Button, Icon, Typography } from '@bharatpe/bharat-ui';
import React, { useEffect } from 'react';
import { WarningRounded } from '@bharatpe/bharat-ui/web/Icons';
import { closeNativeSupport } from 'utils/nativeSupport';
import history from 'utils/History';
import { sendEvent } from 'utils/Sentry';
import { deviceBindingRedirectionHandle } from 'utils/deviceBindingHelper';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { UPI_ERROR_CODE } from 'utils/CONSTANT';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

interface IProps {
	handlePrimaryButtonClick: () => void;
	errorObject?: any;
}

const UPIActivationErrorModal: React.FC<IProps> = ({ handlePrimaryButtonClick, errorObject }) => {
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		switch (errorObject?.error) {
			case 'Maximum device binding attempts exceeded.':
				logAnalyticsEvent({
					trigger_point: 'Modal view',
					Product: 'AutoPayUPI',
					Flow: 'SetupUPI',
					Screen: 'Max_attempt',
					Module: 'Modal',
					Action: 'Viewed',
				});
				break;
			case 'Please use mobile data to authenticate':
				break;
			default:
				break;
		}
	}, [errorObject]);

	const getErrorTitle = () => {
		if (errorObject?.error == 'Maximum device binding attempts exceeded.') {
			return languageData.MAX_THREE_ATTEMPT_ALLOWED;
		} else if (errorObject?.error == 'Please use mobile data to authenticate') {
			return languageData.SWITCH_TO_MOBILE_DATA;
		} else if (UPI_ERROR_CODE.includes(errorObject?.errorCode)) {
			return errorObject?.error;
		} else {
			sendEvent(errorObject);
			return 'Something went wrong';
		}
	};
	const getErrorSubTitle = () => {
		switch (errorObject?.error) {
			case 'Maximum device binding attempts exceeded.':
				return 'You are allowed to attempt UPI linking only 3 times in 24 hours.';
			case 'Please use mobile data to authenticate':
				return 'If you’re on wifi, turn on your mobile data';
			default:
				return '';
		}
	};

	const buttonClick = () => {
		switch (errorObject?.error) {
			case 'Maximum device binding attempts exceeded.':
				deviceBindingRedirectionHandle(true);
				logAnalyticsEvent({
					trigger_point: `Clicks on Done`,
					Product: 'AutoPayUPI',
					Flow: 'SetupUPI',
					Screen: 'Max_attempt',
					Module: 'Done',
					Element: 'CTA',
					Action: 'Tapped',
					ctaType: 'done',
				});
				break;
			case 'Please use mobile data to authenticate':
				history.push({
					pathname: '/upi/sim-binding',
				});
				break;
			default:
				handlePrimaryButtonClick();
		}
	};
	return (
		<BottomSheet visible={true} showCloseButton={false} rounded>
			<div className="p4 flex flex-column">
				<Icon icon={WarningRounded} className="mr2 failed-logo" width={40} height={40} />
				<Typography variant="Bold500 danger" className="mt2">
					{getErrorTitle()}
				</Typography>
				<Typography variant="Regular200" className="grey mt2 mb5">
					{getErrorSubTitle()}
				</Typography>
				<Button onClick={buttonClick} color="primary" className="mr2">
					Done
				</Button>
			</div>
		</BottomSheet>
	);
};

export default UPIActivationErrorModal;
